import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { WallFolder, CreateWallFolderDto } from 'types';

export const createWeatherFolder = (
  data: CreateWallFolderDto
): Promise<WallFolder> => {
  return axios.post('/api/folders/weather', data);
};

type UseCreateWeatherFolderOptions = {
  config?: MutationConfig<typeof createWeatherFolder>;
};

export const useCreateWeatherFolder = ({
  config,
}: UseCreateWeatherFolderOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousWeatherFolders) {
        queryClient.setQueryData(
          ['weatherFolders'],
          context.previousWeatherFolders
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['weatherFolders']);
    },
    ...config,
    mutationFn: createWeatherFolder,
  });
};
